<template>
  <!-- Modal -->
  <Modal
    id="create-tag-modal"
    title="Crea Tag"
    :submit-btn-disabled="loading || duplicateTag"
    @submit="createTag()"
  >
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status" aria-hidden="true">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div>
        <label>
          Nome tag:
          <input
            id="tag-name"
            type="text"
            class="form-control"
            v-model="name"
          />
          <p v-if="duplicateTag" class="form-text">Questo nome è già stato utilizzato.</p>
        </label>
      </div>
      <div>
        <label>
          Annida sotto a:
          <select class="form-control" v-model="parent">
            <option value="">Nessuno</option>
            <option v-for="tag in tags" :value="tag.id">{{tag.display}}</option>
          </select>
        </label>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import bus from '@/bus.js';
import { ref, onBeforeUnmount, watch, inject } from 'vue';
import * as tagService from '@/services/tag.service.js';
import Modal from './Modal.vue';

const hideModal = inject('hideModal');

const name = ref('');
const parent = ref('');
const tags = ref(null);
const accountId = ref('');
const loading = ref(false);
const duplicateTag = ref(false);

function isDuplicateTag(name) {
  return tags.value.find((t) => t.name == name) != null;
}

async function createTag() {
  let parentId = null;
  if (parent.value != '') {
    parentId = parent.value;
  }

  await tagService.create(accountId.value, name.value, parentId);

  bus.$emit('tagAdded', { account: accountId.value });

  hideModal('create-tag-modal');
}

async function init(account, tagTrees = null) {
  loading.value = true;

  accountId.value = account

  if (tagTrees == null) {
    tagTrees = await tagService.getAllAsTrees(accountId.value);
  }

  tags.value = tagService.flattenTagTrees(tagTrees);

  loading.value = false;
}

// Initialize callbacks
bus.$on('init-create-tag-modal', init);

onBeforeUnmount(() => {
  bus.$off('init-create-tag-modal', init);
});

watch(name, (newValue) => {
  if (isDuplicateTag(newValue)) {
    duplicateTag.value = true;
  } else {
    duplicateTag.value = false;
  }
})

</script>

<style>
</style>
